var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinWorldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8552 7.99793C14.7559 6.74279 14.2872 5.54515 13.5082 4.55603C12.7292 3.56692 11.6747 2.83064 10.4778 2.44003C9.28083 2.04943 7.99503 2.022 6.78253 2.3612C5.57003 2.7004 4.48511 3.39104 3.66461 4.34602C2.84411 5.30101 2.32476 6.47757 2.17206 7.72733C2.01936 8.97709 2.24016 10.2441 2.80659 11.3685C3.37303 12.493 4.25974 13.4245 5.35491 14.0457C6.45007 14.6668 7.70465 14.9498 8.96041 14.8588",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54883 6.375H14.4488",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54883 10.6245H8.85299",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14625 2.125C6.95295 4.03723 6.32031 6.24599 6.32031 8.5C6.32031 10.754 6.95295 12.9628 8.14625 14.875",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85547 2.125C10.0516 4.04067 10.6844 6.25432 10.6816 8.51275",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9594 14.2523C15.2567 13.9552 15.4591 13.5765 15.5412 13.1643C15.6232 12.7521 15.5812 12.3248 15.4203 11.9365C15.2595 11.5481 14.9872 11.2162 14.6377 10.9827C14.2882 10.7492 13.8773 10.6245 13.457 10.6245C13.0367 10.6245 12.6258 10.7492 12.2764 10.9827C11.9269 11.2162 11.6545 11.5481 11.4937 11.9365C11.3329 12.3248 11.2909 12.7521 11.3729 13.1643C11.455 13.5765 11.6574 13.9552 11.9547 14.2523C12.2507 14.5491 12.7515 14.9925 13.457 15.5833C14.2015 14.9529 14.703 14.5095 14.9594 14.2523Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.459 12.75V12.7586",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWorldIcon);
export default __webpack_public_path__ + "static/media/pin-world-icon.aad85746978d83f5bfa7d16dd61ff7f1.svg";
export { ForwardRef as ReactComponent };